import { useEffect } from 'react';
import { usePWA } from '@/hooks/usePWA';

export const useMenuCache = (menuSlug?: string, menuData?: any) => {
  const { cacheMenu, isOnline } = usePWA();

  useEffect(() => {
    if (menuSlug && menuData && isOnline) {
      const menuUrl = window.location.href;
      
      setTimeout(() => {
        cacheMenu(menuUrl);
        console.log('📋 Menú guardado para acceso offline:', menuSlug);
        
        // Notificar al usuario si es la primera vez
        const cacheKey = `menu_cached_${menuSlug}`;
        if (!localStorage.getItem(cacheKey)) {
          localStorage.setItem(cacheKey, 'true');
        }
      }, 2000);
    }
  }, [menuSlug, menuData, isOnline, cacheMenu]);

  return {
    isOnline,
    cacheCurrentMenu: () => {
      if (menuSlug) {
        cacheMenu(window.location.href);
      }
    }
  };
};